import ManualBillingDocumentAmountTva from '@/generated/controls/manualBillingDocument/ManualBillingDocumentAmountTva.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentAmountTva
})
